import { Tooltip } from "antd";

/** 位置类型 */
export type PositionType = 'prefix' | 'suffix';

/**
 * 显示的内容
 * @param str 字符串
 * @param options 选项 
 */
const showText = (val: string, options?: {
    /** 显示的字符长度，默认8位 */
    showLength?: number;
    /** 位置 */
    pos?: PositionType;
    /** 提示文字 */
    tooltipText?: string;
}) => {
    const { showLength = 8, pos = 'prefix', tooltipText } = options || {};
    return (
        <Tooltip placement="topLeft" title={tooltipText ? tooltipText : val}>{
            (typeof val !== "undefined" && val !== null) ?
                (pos === 'prefix' ?
                    (val.length >= showLength! ? `${val.substring(0, showLength)}......` : val)
                    :
                    (val.length >= showLength! ? `......${val.substring(val.length - showLength!, val.length)}` : val)
                )
                : ''
        }</Tooltip>
    )
}

/**
 * 表头id显示
 * @param options 选项
 * @example getColumnsheadId({
        title: '微信',
        dataIndex: 'unionId',
        showLength: 10,
        pos: 'suffix',
        val: any
    })
 * @returns 
 */
const getColumnsheadId = (options: {
    /** 展示的名称，默认:id */
    title?: string,
    /** 数据名，默认:id */
    dataIndex?: string,
    /** 显示的字符长度，默认8位  */
    showLength?: number,
    /** 位置 */
    pos?: PositionType,
    /** 返回模式 */
    returnType?: 'Array' | 'Object',
    /** toolTip显示的文字 */
    val?: string
}) => {
    let { title = 'id', dataIndex = 'id', showLength = 8, pos = 'prefix', returnType = 'Array', val } = options;
    let columnsheadId: any;

    // ★ 改：统一做字符串化 + 空值防御
    //    - textAny 可能是 number / undefined / null，直接 .length 会出错或走错分支；
    //    - 统一转成 string 再判断长度，更稳。
    const getToolTip = (textAny?: string | number | null) => {
        const str = (textAny === undefined || textAny === null) ? '' : String(textAny);
        return (
            <Tooltip placement="topLeft" title={textAny}>{
                str === '' ? '' :
                    (pos === 'prefix' ?
                        (str.length >= showLength! ? str.substring(0, showLength) + '......' : str)
                        :
                        (str.length >= showLength! ? '......' + str.substring(str.length - showLength!, str.length) : str)
                    )
            }</Tooltip>
        )
    }

    switch (returnType) {
        case 'Object':
            // ★ 说明：returnType='Object' 时，text 必须是调用方显式传入的字符串，
            //   因为没有单元格值可用（脱离表格上下文）。
            columnsheadId = getToolTip(val);
            break;
        default:
            // ★ 核心修复：render 必须接收单元格的值（AntD 会把 value 作为第一个参数传入）。
            //   - 之前写的是 render: () => getToolTip(val)，用的是外层 options.text，
            //     不传 val 时 val === undefined，于是每个单元格都渲染成空字符串。
            //   - 现在改成 render: (value: any) => getToolTip(val ?? value)：
            //     · 若调用方显式传了 text，用 val 覆盖（兼容老用法）；
            //     · 否则用单元格自身的值 value。
            columnsheadId = [
                {
                    title,
                    dataIndex,
                    render: (value: any) => getToolTip(val ?? value)
                },
            ];
            break;
    }
    return columnsheadId;
};

/**
 * 表头id显示，头8位......
 */
const columnsheadId = [
    {
        title: 'id',
        dataIndex: 'id',
        render: (val: any) => <Tooltip placement="topLeft" title={val}>{
            (typeof val !== "undefined" && val !== null) ?
                (val.length >= 8 ? `${val.substring(0, 8)}......` : val)
                : ''
        }</Tooltip>
    },];

/**
 * 表头id显示，尾8位......
 */
const columnsheadEndId = [
    {
        title: 'id',
        dataIndex: 'id',
        render: (val: any) => <Tooltip placement="topLeft" title={val}>{
            (typeof val !== "undefined" && val !== null) ?
                (val.length >= 8 ? `......${val.substring(val.length - 8, val.length)}` : val)
                : ''
        }</Tooltip>
    },];

/**
 * 表头id显示，Uuid，13位......
 */
const columnsheadUuid = [
    {
        title: 'id',
        dataIndex: 'id',
        render: (val: any) => <Tooltip placement="topLeft" title={val}>{
            typeof val !== "undefined" ?
                (val.length >= 13 ? `${val.substring(0, 13)}......` : val)
                : ''
        }</Tooltip>
    },];

export {
    getColumnsheadId,
    columnsheadId,
    columnsheadEndId,
    columnsheadUuid,
    showText
};